module.exports = __webpack_public_path__ + "static/Bitkingz-7b9cd104ecc35e257e6b3beb74756d3c.jpg";